import { useEffect, useState } from 'react';

export const useSafeArea = () => {
  const [safeAreaInsets, setSafeAreaInsets] = useState({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  });

  useEffect(() => {
    // Function to get safe area insets
    const getSafeAreaInsets = () => {
      // Try to get from CSS custom properties first
      const style = getComputedStyle(document.documentElement);
      
      // Get safe area insets from CSS environment variables
      const top = parseInt(style.getPropertyValue('env(safe-area-inset-top)') || '0');
      const bottom = parseInt(style.getPropertyValue('env(safe-area-inset-bottom)') || '0');
      const left = parseInt(style.getPropertyValue('env(safe-area-inset-left)') || '0');
      const right = parseInt(style.getPropertyValue('env(safe-area-inset-right)') || '0');
      
      // If we're in a browser environment, these will likely be 0
      // For testing purposes, we can simulate safe areas
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      let simulatedTop = top;
      let simulatedBottom = bottom;
      let simulatedLeft = left;
      let simulatedRight = right;
      
      // Simulate safe areas for testing in browser
      if (isIOS || isMobile) {
        if (top === 0) simulatedTop = 44; // iPhone status bar height
        if (bottom === 0) simulatedBottom = 34; // iPhone home indicator height
      }
      
      return {
        top: simulatedTop,
        bottom: simulatedBottom,
        left: simulatedLeft,
        right: simulatedRight
      };
    };

    // Set initial safe area insets
    setSafeAreaInsets(getSafeAreaInsets());

    // Update on orientation change
    const handleOrientationChange = () => {
      setTimeout(() => {
        setSafeAreaInsets(getSafeAreaInsets());
      }, 100);
    };

    // Update on resize
    const handleResize = () => {
      setSafeAreaInsets(getSafeAreaInsets());
    };

    // Update on visual viewport change (for mobile browsers)
    const handleVisualViewportChange = () => {
      setSafeAreaInsets(getSafeAreaInsets());
    };

    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleResize);
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleVisualViewportChange);
    }

    // Force light theme
    document.documentElement.style.setProperty('color-scheme', 'light');
    document.body.style.setProperty('color-scheme', 'light');
    document.body.style.setProperty('background-color', '#ffffff');

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleVisualViewportChange);
      }
    };
  }, []);

  return safeAreaInsets;
};

// CSS utility function to apply safe area styles
export const getSafeAreaStyles = (insets) => ({
  // paddingTop: `${insets.top}px`,
  // paddingBottom: `${insets.bottom}px`,
  // paddingLeft: `${insets.left}px`,
  // paddingRight: `${insets.right}px`,
  minHeight: '100vh',
  minHeight: '100dvh',
  backgroundColor: '#ffffff'
}); 